import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  FILAVIRTUAL,
  FILAVIRTUAL_FAIL,
  FILAVIRTUAL_RESET,
  FILAVIRTUAL_SUCCESS,
} from "../ActionTypes";

export const wsPostFilaVirtual = (filaVirtualDto, nextStep) => (dispatch) => {
  dispatch({ type: FILAVIRTUAL });

  axiosAutoCheck().then((respuesta) => {
    respuesta
      .post(`/FilaVirtual/`, filaVirtualDto)
      .then((resp) => {
        dispatch({ type: FILAVIRTUAL_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true);
      })
      .catch((err) => {
        dispatch({ type: FILAVIRTUAL_FAIL, payload: err?.response?.data });
        if (nextStep) nextStep(false);
      });
  });
};

export const filaVirtualReset = () => (dispatch) => {
  dispatch({ type: FILAVIRTUAL_RESET });
};
